import { Button } from '@components/Button'
import { HeroIcon } from '@components/HeroIcon'
import { Modal } from '@components/Modal'
import { useIsMobile } from '@hooks/useIsMobile'
import { useTranslation } from 'react-i18next'
import { Dialog, Text, XStack, YStack } from 'tamagui'
import { useBrand } from '@hooks/useBrand'

interface IPaymentRefundGenericErrorModalProps {
  onClose: () => void
  open: boolean
}

export function PaymentRefundGenericErrorModal({
  onClose,
  open,
}: IPaymentRefundGenericErrorModalProps) {
  const { t } = useTranslation('OrderDetails')
  const brand = useBrand()
  const email = brand.paymentsEmail

  const isMobile = useIsMobile()

  const handleOpenEmail = () => {
    window.open(`mailto:${email}`, '_blank')
  }

  return (
    <Modal
      onClose={onClose}
      open={open}
      snapPoints={isMobile ? [370, 190] : [60, 100]}
      snapPointsMode={isMobile ? 'constant' : 'percent'}
      position={isMobile ? 0 : undefined}
      backdropOpacity={0.9}
      maxWidth={400}
      dismissOnSnapToBottom={isMobile}
      shouldAdapt={isMobile}
    >
      <YStack
        gap="$size.spacing-xs"
        paddingHorizontal="$size.spacing-xs"
        paddingVertical="$size.spacing-md"
        $gtSm={{
          p: '$size.spacing-lg',
          width: 400,
        }}
        height={isMobile ? 'auto' : '100%'}
        justifyContent="flex-start"
        alignItems="center"
      >
        <YStack gap={16} alignItems="center" width="100%" maxWidth={400}>
          <HeroIcon
            icon={['fal', 'circle-exclamation']}
            color="$danger-100"
            size={48}
          />
          <Dialog.Title
            color="$text-primary"
            ff="$mulishBold"
            fontSize="$font-size-md"
            textAlign="center"
            whiteSpace="pre-line"
            $gtSm={{
              paddingHorizontal: 20,
            }}
          >
            {t('refundGenericError.title')}
          </Dialog.Title>
          <Dialog.Description
            color="$text-secondary"
            fontFamily="$mulishRegular"
            fontSize="$font-size-xxs"
            textAlign="center"
            whiteSpace="pre-line"
            lineHeight={21}
          >
            {t('refundGenericError.descriptionPart1', { brand: brand.name })}
            {'\n'}
            <Text
              color="$accent"
              fontFamily="$mulishRegular"
              fontSize="$font-size-xxs"
              textDecorationLine="underline"
              onPress={handleOpenEmail}
            >
              {email}
            </Text>{' '}
            {t('refundGenericError.descriptionPart2', { brand: brand.name })}
          </Dialog.Description>
          <XStack
            justifyContent="center"
            alignItems="center"
            width="100%"
            marginTop="$size.spacing-xs"
          >
            <Button
              variant="primary"
              onPress={onClose}
              focusable={false}
              size="large"
              width="100%"
              style={{
                fontWeight: 700,
              }}
            >
              {t('refundGenericError.openTicketButton')}
            </Button>
          </XStack>
        </YStack>
      </YStack>
    </Modal>
  )
}
